import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faGoogleScholar } from '@fortawesome/free-brands-svg-icons/faGoogleScholar';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.


import { faOrcid } from '@fortawesome/free-brands-svg-icons/faOrcid';



const data = [
  {
    link: 'https://github.com/Leandropassosjr',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/leandropassosjr',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/leandropassosjr',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://www.linkedin.com/in/leandropassosjr',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/leandropassosjr',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:leandro.passos@unesp.br',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: 'https://orcid.org/0000-0003-3529-3109',
    label: 'ORCID',
    icon: faOrcid,
  },
  {
    link: 'https://scholar.google.com.br/citations?user=VVCXeH0AAAAJ&hl=en',
    label: 'Google Scholar',
    icon: faGoogleScholar,
  }
];

export default data;
